@use '../../styles/global' as *;
@use '../@shared/kol-button-mixin' as *;
@use '../@shared/kol-popover-button-mixin' as *;
@use '../tooltip/style' as *;

@layer kol-component {
	@include kol-button-styles('kol-button');
	@include kol-popover-button-styles;

	.kol-popover-button {
		&--open {
			.kol-button__tooltip {
				display: none;
			}
		}

		&--inline {
			.kol-button {
				min-width: 0;
				min-height: 1em;
			}
		}
	}
}
